import { render, staticRenderFns } from "./recordToolbar.vue?vue&type=template&id=318b42c0&scoped=true&"
import script from "./recordToolbar.vue?vue&type=script&lang=js&"
export * from "./recordToolbar.vue?vue&type=script&lang=js&"
import style0 from "./recordToolbar.vue?vue&type=style&index=0&id=318b42c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b42c0",
  null
  
)

export default component.exports